import { SimpleProductTeaser as UISimpleProdutTeaser } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/SimpleProductTeaser/SimpleProductTeaser";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { ProductsMap } from "@/libs/commerce/products";
import { getResizedImageUrl } from "@/utils/getResizedImageUrl";

import { simpleProductTeaserInputs } from "./SimpleProductTeaser.builder";

type SimpleProductTeaserProps = BuilderComponentProps<
  typeof simpleProductTeaserInputs
>;

export function SimpleProductTeaser({
  name,
  src,
  link,
  products,
  sku,
}: SimpleProductTeaserProps & { products: ProductsMap }) {
  const { __ } = useTranslations();
  const productData = products?.[sku?.options?.product];

  if (!productData) {
    return null;
  }

  return (
    <UISimpleProdutTeaser
      name={name || productData.title || ""}
      src={getResizedImageUrl(src || productData.image) || ""}
      link={{
        href: link?.href || productData.pageUrl || "/",
        text: link?.text || __("product.button.buynow"),
      }}
      alt={name || productData.title || ""}
    />
  );
}
